module.exports = __webpack_public_path__ + "static/img/store-logos-apple.b16159a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store-logos-apple.png
// module id = GvdH
// module chunks = 0